var map = {
	"./Dividends/Dividends.route.tsx": 444,
	"./EcosystemPartners/EcosystemPartners.route.tsx": 445,
	"./LPPosition/LPPosition.route.tsx": 446,
	"./LandingPage/LandingPage.route.tsx": 447,
	"./LaunchPad/LaunchPad.route.tsx": 448,
	"./LaunchPadDetail/LaunchPadDetail.route.tsx": 449,
	"./LeaderBoard/LeaderBoard.route.tsx": 450,
	"./Liquidity/Liquidity.route.tsx": 451,
	"./LiquidityDetail/LiquidityDetail.route.tsx": 452,
	"./LiquidityPartner/LiquidityPartner.route.tsx": 453,
	"./LiquidityPartnerDetail/LiquidityPartnerDetail.route.tsx": 454,
	"./Profile/Profile.route.tsx": 455,
	"./Swap/Swap.route.tsx": 456,
	"./xGalo/xGalo.route.tsx": 457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 856;